/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import {HTTP_ERROR_RESPONSE_INTERFACE} from "@Services/Interfaces/Http/Response/Error";

import DEFAULT_REQUEST_HEADERS from "@Services/Interfaces/Http/Request/Headers";


export const DELETE_MONITORY_NOTE_REQUEST_HANDLER = async (
    REST_API_ENDPOINT_URL: string, MONITORY_NOTE_ID: string, USER_ID: string | number
): Promise<any> => {

    if (!REST_API_ENDPOINT_URL || !MONITORY_NOTE_ID || !USER_ID) {
        return {ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"};
    }

    const MONITORY_NOTE_DELETE_REQUEST_DATA = {
        UserId: USER_ID, TransportNotificationNo: MONITORY_NOTE_ID
    };

    try {

        const RESPONSE = await fetch(REST_API_ENDPOINT_URL, {
            method: "DELETE", headers: DEFAULT_REQUEST_HEADERS,
            body: JSON.stringify(MONITORY_NOTE_DELETE_REQUEST_DATA)
        });

        if (RESPONSE.status === 204) {
            return {success: true};
        } else {
            const CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await RESPONSE.json();
            return {ErrorCode: RESPONSE.status, UserMessage: CONTENT.UserMessage};
        }

    } catch (e) {
        return {ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"};
    }

    return {ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"};

};


export default DELETE_MONITORY_NOTE_REQUEST_HANDLER;
